import type { ComponentType, PropsWithChildren } from 'react';
import React, { Fragment } from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { ExternalSharePageLoader } from '@confluence/external-share/entry-points/ExternalSharePage.ts';
import { expVal } from '@confluence/feature-experiments';
import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { getUniquePageLoadId } from '@confluence/unique-page-load-id/entry-points/UniquePageLoadId.ts';

export function getAccessLinkRoute({
	ContextProvider = Fragment,
	NotFound = Fragment,
}: GetAccessLinkRouteArgs = {}) {
	function AccessLinkRoute({ params: { shareToken }, hash }: RouteMatch) {
		if (!expVal('shareable_links_m0', 'isEnabled', false)) {
			return <NotFound />;
		}

		return (
			<ContextProvider>
				<ExternalSharePageLoader shareToken={shareToken} queryHash={hash} />
			</ContextProvider>
		);
	}

	AccessLinkRoute.NAVIGATION_PARAMS = ({ name }: RouteMatch) => ({
		Screen: {
			screenEvent: {
				name: 'viewPageScreen',
				attributes: {
					isPublicView: true,
					isAccessLinkView: true,
					pageLoadInfo: getUniquePageLoadId(),
				},
			},
			pageState: {
				routeName: name,
			},
		},
		MainLayout: {
			navView: PRODUCT_HOME_ID,
		},
	});

	return AccessLinkRoute;
}

type GetAccessLinkRouteArgs = {
	ContextProvider?: ComponentType<PropsWithChildren<{}>>;
	NotFound?: ComponentType;
};

export const AccessLinkRouteForSSR = getAccessLinkRoute();
